import { BaseService } from '../../../../core/services/base.service';
import { UserListItem, UserSearchParam } from '../../interfaces/user/user-type.interface';
import { Observable } from 'rxjs';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

export abstract class UserService extends BaseService<UserListItem> {
    abstract override findAll(searchParam: UserSearchParam): Observable<PageResponse<UserListItem>>;
    abstract override find(id: string): Observable<UserListItem>;
    abstract override create(data: any): Observable<any>;
    abstract override update(id: string, data: any): Observable<any>;
    abstract override delete(id: string): Observable<void>;
    abstract updateStatus(id: string, status: boolean): Observable<void>;
    abstract updatePassword(uniqueId: string, password: string): Observable<void>;
}
